import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';
import styles from './SidebarLogo.module.css';

export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <div
      className={styles.root}
      style={{
        width: sidebarConfig.drawerWidthClosed,
        height: 3 * sidebarConfig.logoHeight,
      }}
    >
      <Link
        to="/"
        underline="none"
        className={styles.link}
        style={{ width: sidebarConfig.drawerWidthClosed }}
        aria-label="Home"
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
